import type { RouteRecordRaw } from 'vue-router'
import { area, deviceType, page, layout } from '@/router/routes/utils'
import { DeviceType } from '@/api/client'
import { areas } from '../areas'
import { BarBackgroundStyle } from '@/composables/useNativeStyle'

const multiUserRoutes: Array<RouteRecordRaw> = deviceType(
  [DeviceType.TERMINAL],
  [
    {
      path: '/congratulation',
      name: 'congratulation',
      meta: {
        showGradient: true,
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      },
      component: page('authentication/CongratulationPage'),
    },
    {
      path: '/deviceHome',
      name: 'deviceHome',
      props: (route) => {
        console.log('ROUTE TO DEVICEHOME PARAMS', route.params)
        return {
          lastStampedEmployeeId: Number(route.params.lastStampedEmployeeId),
        }
      },
      meta: {
        showGradient: true,
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      },
      component: page('multi-user/device-home-page/DeviceHomePage'),
    },
    {
      path: '/accessmenu/:employeeId',
      name: 'accessmenu',
      props: (route) => ({
        employeeId: Number(route.params.employeeId),
        entered_pin: String(route.params.entered_pin),
        timestamp: Date.now(), // passing this to force reset of the exit timer
      }),
      meta: {
        showGradient: true,
        statusBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
        navigationBarBackgroundStyle: BarBackgroundStyle.PRIMARY,
      },
      component: page('multi-user/access-menu-page/AccessmenuPage'),
    },
  ],
)

const multiUserRoutesForMyArea: Array<RouteRecordRaw> = deviceType(
  [DeviceType.TERMINAL],
  area(areas.MULTI_USER_MY_AREA, [
    {
      path: '/deviceMyArea',
      name: 'deviceMyArea',
      meta: {
        showGradient: false,
      },
      component: page('my-area/multi-user/MyAreaPage'),
    },
    {
      path: '/deviceCorrection',
      name: 'deviceCorrection',
      meta: {
        showGradient: false,
      },
      component: page('correction/multi-user/CorrectionPage'),
    },
    {
      path: '/deviceAbsences',
      name: 'deviceAbsences',
      meta: {
        showGradient: false,
      },
      component: page('absence/multi-user/AbsencesPage'),
    },
    {
      path: '/deviceAbsenceDetail/:id',
      name: 'deviceAbsence',
      props: (route) => ({
        id: Number(route.params.id),
      }),
      meta: {
        showGradient: false,
      },
      component: page('absence/multi-user/AbsencePage'),
    },
    {
      path: '/deviceShiftPlan',
      name: 'deviceShiftPlan',
      meta: {
        showGradient: false,
      },
      component: page('shift-plan/multi-user/ShiftPlanPage'),
    },
    {
      path: '/deviceShift/:id',
      name: 'deviceShift',
      props: (route) => ({
        id: Number(route.params.id),
      }),
      meta: {
        showGradient: false,
      },
      component: page('shift-plan/multi-user/ShiftPage'),
    },
    {
      path: '/deviceCalendar',
      name: 'deviceCalendar',
      props: (route) => ({
        id: Number(route.params.id),
      }),
      meta: {
        showGradient: false,
      },
      component: page('shift-plan/multi-user/CalendarPage'),
    },
    {
      path: '/deviceShifts',
      name: 'deviceShifts',
      meta: {
        showGradient: false,
      },
      component: page('shift-plan/multi-user/ShiftsPage'),
    },
  ]),
)

const multiUserRoutesForWorkArea: Array<RouteRecordRaw> = deviceType(
  [DeviceType.TERMINAL],
  area(areas.WORK_AREA, [
    {
      path: '/intermediate/:task_id/:employee_id',
      name: 'intermediate',
      props: (route) => ({
        taskId: Number(route.params.task_id),
        employeeId: Number(route.params.employee_id),
      }),
      meta: {
        showGradient: false,
      },
      component: page('multi-user/access-menu-page/IntermediatePage'),
    },
  ]),
)

const multiUserRoutesForAdminArea: Array<RouteRecordRaw> = deviceType(
  [DeviceType.TERMINAL],
  area(areas.MULTI_USER_ADMIN_AREA, [
    {
      path: '/admin',
      name: 'admin',
      meta: {
        showGradient: false,
      },
      component: page('multi-user/admin-page/AdminPage'),
    },
  ]),
)

const routesWithDefaultLayout = [
  {
    path: '',
    component: layout('TerminalPageLayout'),
    children: [
      ...multiUserRoutes,
      ...multiUserRoutesForWorkArea,
      ...multiUserRoutesForMyArea,
      ...multiUserRoutesForAdminArea,
    ],
  },
]

export default routesWithDefaultLayout
